// extracted by mini-css-extract-plugin
export default {"productGrid":"O2-z","centerLink":"P2-z","productSection":"Q2-z","item":"R2-z","ctaButton":"S2-z"};